/* eslint-disable import/prefer-default-export */
import React from 'react'

import PropTypes from 'prop-types'
import s from './ListingWithVote.module.css'

import { ImageWrapper } from './components/ImageWrapper'
import { CardBottom } from './components/CardBottom'

export function ListingWithVote(props) {
  const { listing, image, url, signedIn, neighborhood, shortAddress, collectionId, votes, ownership } = props

  return (
    <div className={s.root}>
      <ImageWrapper image={image} url={url} listing={listing} />
      <CardBottom
        shortAddress={shortAddress}
        url={url}
        listing={listing}
        signedIn={signedIn}
        neighborhood={neighborhood}
        collectionId={collectionId}
        votes={votes}
        showVote={['owner', 'shared'].includes(ownership)}
      />
    </div>
  )
}

ListingWithVote.defaultProps = {
  collectionId: null,
  image: '',
  url: '',
  neighborhood: '',
  shortAddress: '',
  signedIn: false,
}

ListingWithVote.propTypes = {
  collectionId: PropTypes.number,
  image: PropTypes.string,
  url: PropTypes.string,
  shortAddress: PropTypes.string,
  neighborhood: PropTypes.string,
  listing: PropTypes.shape({
    id: PropTypes.number,
  }).isRequired,
  signedIn: PropTypes.bool,
}
